module.exports = __webpack_public_path__ + "img/mail-icon.954383c7.png";